import axios from 'axios'
import lodash from 'lodash'
import qs from 'qs'

import store from '@/store'
import errorHandler from '@/errorHandler'


class ApiError extends Error {
  constructor(code, status, message) {
    super(message)
    this.code = code
    this.status = status
    this.message = message
  }
}


export default {

  install(Vue, config) {

    axios.interceptors.response.use(null, async error => {
      if (error.response.data) {
        const { code, status, message } = error.response.data
        error = new ApiError(code, status, message)
      }
      errorHandler(error)
      return Promise.reject(error)
    })

    lodash.merge(axios.defaults, {

      baseURL: config.api.baseURL,

      paramsSerializer: params => qs.stringify(params),

      transformRequest: [(data, headers) => {
        const { token } = store.state.auth


        if (token) {
          headers['Authorization'] = `Bearer ${token}`
        }

        if(!headers['Content-Type']) {
          headers['Content-Type'] = 'application/json'
          return JSON.stringify(data)
        }
        return data
      }],

      transformResponse: [data => {
        return data ? JSON.parse(data) : null
      }],

    })


    Vue.prototype.$isApiError = error => {
      return error instanceof ApiError
    }

    Vue.prototype.$axios = axios
  }

}
